import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { RestService } from '@stdoutsrl/design-kit';
import { LoaderService } from '../../service/loader.service';

@Component({
  selector: 'app-your-quizs',
  templateUrl: './your-quizs.component.html',
  standalone: false
})
export class YourQuizsComponent implements OnInit {

  constructor(private rest: RestService, private loader: LoaderService, private router: Router) { }

  quizList: any[] = []
  showModalDelete = false
  currentQuiz: any

  ngOnInit(): void {
    this.getQuizs()
  }

  goHome(route:string){
    // this.router.navigate(t('routes.home.path'))
    this.router.navigate([route])
  }

  getQuizs(element?:any) {
    this.loader.on()
    this.rest.get('/quiz').subscribe({
      next: (value: any) => {
        this.quizList = value.data
        if(element){
          element.style.opacity = '1'
        }
        this.loader.off(true)
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }

  addQuiz(t: any) {
    this.loader.on()
    this.rest.post('/quiz', { title: '', description: '', is_active: 0, requires_fiscal_code: 0 }).subscribe({
      next: (value: any) => {
        this.loader.off(true)
        this.router.navigate([t('routes.createQuiz.path').replace(':id', value.id)])
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }

  goToQuiz(quiz: any, t: any) {
    this.router.navigate([t('routes.createQuiz.path').replace(':id', quiz.id)])
  }

  deleteQuiz(quiz: any) {
    this.loader.on()
    this.rest.delete(`/quiz/${quiz.id}`).subscribe({
      next: (value: any) => {
        this.loader.off(true)
        let myQuizToDelete = document.getElementById(`quiz-card-${quiz.id}`)
        if (myQuizToDelete) {
          this.showModalDelete = false
          myQuizToDelete.style.opacity = '0'
          let left = myQuizToDelete.getBoundingClientRect().left
          let top = myQuizToDelete.getBoundingClientRect().top
          let newQuiz = document.createElement('div')
          let trashCan = document.createElement('div')
          trashCan.innerHTML = `
      <svg style="position:relative;top:100px;left:0px" id="svg-trash-top" width="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.0024 1.49976H1.99979C1.44739 1.49976 0.999573 1.94757 0.999573 2.49997V3.00008C0.999573 3.55249 1.44739 4.0003 1.99979 4.0003H14.0024C14.5548 4.0003 15.0026 3.55249 15.0026 3.00008V2.49997C15.0026 1.94757 14.5548 1.49976 14.0024 1.49976Z" fill="white"/>
</svg>
<svg width="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.32703 5.00171C2.29189 5.00152 2.2571 5.00874 2.22494 5.0229C2.19278 5.03705 2.16396 5.05783 2.14037 5.08387C2.11677 5.10991 2.09893 5.14064 2.08801 5.17403C2.07709 5.20743 2.07333 5.24276 2.07697 5.27771L2.89934 13.1719C2.89917 13.1742 2.89917 13.1765 2.89934 13.1788C2.94231 13.5439 3.11785 13.8806 3.39264 14.1248C3.66742 14.3691 4.02233 14.5039 4.38998 14.5038H11.6131C11.9807 14.5038 12.3354 14.3689 12.6101 14.1246C12.8847 13.8804 13.0602 13.5438 13.1031 13.1788V13.1722L13.9242 5.27771C13.9279 5.24276 13.9241 5.20743 13.9132 5.17403C13.9023 5.14064 13.8844 5.10991 13.8608 5.08387C13.8373 5.05783 13.8084 5.03705 13.7763 5.0229C13.7441 5.00874 13.7093 5.00152 13.6742 5.00171H2.32703ZM10.1056 10.6495C10.1531 10.6957 10.191 10.7509 10.2171 10.8119C10.2431 10.8728 10.2567 10.9384 10.2572 11.0046C10.2577 11.0709 10.2449 11.1367 10.2198 11.198C10.1946 11.2593 10.1575 11.315 10.1106 11.3619C10.0638 11.4088 10.008 11.4458 9.94669 11.471C9.88534 11.4961 9.81962 11.5088 9.75333 11.5083C9.68704 11.5078 9.62151 11.4941 9.56056 11.4681C9.4996 11.442 9.44443 11.4041 9.39826 11.3565L8.0017 9.95998L6.60483 11.3565C6.51061 11.4481 6.38415 11.4989 6.25279 11.4979C6.12142 11.497 5.99569 11.4444 5.90278 11.3516C5.80986 11.2587 5.75722 11.133 5.75624 11.0016C5.75525 10.8702 5.80599 10.7438 5.89749 10.6495L7.29436 9.25264L5.89749 7.85577C5.80599 7.76151 5.75525 7.63503 5.75624 7.50366C5.75722 7.37229 5.80986 7.24659 5.90278 7.15372C5.99569 7.06084 6.12142 7.00826 6.25279 7.00733C6.38415 7.0064 6.51061 7.0572 6.60483 7.14874L8.0017 8.5453L9.39826 7.14874C9.49248 7.0572 9.61894 7.0064 9.7503 7.00733C9.88167 7.00826 10.0074 7.06084 10.1003 7.15372C10.1932 7.24659 10.2459 7.37229 10.2469 7.50366C10.2478 7.63503 10.1971 7.76151 10.1056 7.85577L8.70873 9.25264L10.1056 10.6495Z" fill="white"/>
</svg>
      `
          trashCan.style.height = '200px'

          trashCan.style.width = '100px'
          trashCan.style.position = 'fixed'
          trashCan.style.zIndex = '10000'
          trashCan.style.right = '0px'
          trashCan.style.bottom = '-250px'

          trashCan.style.transitionDuration = '1500ms'
          setTimeout(() => {
            let topTrash = document.getElementById('svg-trash-top')
            if (topTrash) {
              topTrash.style.transform = 'rotate(0deg) scale(1)'
            }
            trashCan.style.bottom = '-8px'
            setTimeout(() => {

              if (topTrash) {
                topTrash.style.transitionDuration = '500ms'
                topTrash.style.left = '0px'
                topTrash.style.top = '60px'
                topTrash.style.transform = 'rotate(65deg) scale(1)'
                setTimeout(() => {
                  topTrash.style.top = '100px'
                  topTrash.style.transform = 'rotate(0deg) scale(1)'
                  setTimeout(() => {
                    trashCan.style.bottom = '-250px'
                    setTimeout(() => {
                      topTrash.remove()
                      trashCan.remove()
                      this.getQuizs(myQuizToDelete)
                    }, 500);
                  }, 500);
                }, 500);
              }
            }, 1200);
          }, 0);

          newQuiz.style.transform = 'scale(1)'
          newQuiz.style.width = 'calc(100vw - 40px)'
          newQuiz.style.height = '167px'
          newQuiz.style.position = 'fixed'
          newQuiz.style.top = top + 'px'
          newQuiz.style.left = left + 'px'
          newQuiz.style.zIndex = '9999'
          newQuiz.classList = 'w-full cursor-pointer h-fit p-5 border-[4px] mb-5 border-white rounded-xl'
          newQuiz.style.transitionDuration = '500ms'
          newQuiz.innerHTML = myQuizToDelete.innerHTML
          document.body.append(newQuiz)
          document.body.append(trashCan)
          setTimeout(() => {
            newQuiz.style.transform = 'rotate(0deg) scale(0.1)'
            newQuiz.style.transformOrigin = 'center center'
            setTimeout(() => {
              newQuiz.classList.add('animation-small-spin-infinite')
              newQuiz.style.top = '100px'
              setTimeout(() => {
                newQuiz.style.left = 'calc(50vw - 40px)'
                setTimeout(() => {
                  newQuiz.style.transitionDuration = '1500ms'
                  newQuiz.style.top = 'calc(100svh + 250px)'
                  setTimeout(() => {
                    newQuiz.style.transform = 'rotate(90deg) scale(0.1)'
                    newQuiz.classList.remove('animation-small-spin-infinite')
                  }, 500);
                }, 350);
              }, 150);
            }, 500);
          }, 0);
        }
        
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }
}
